import axios from "axios";

export default {
  namespaced: true,
  state: () => {
    return {};
  },
  mutations: {},
  getters: {},
  actions: {
    async getAllAward({ commit }, context) {
      const cloneContext = context != null ? context : {};
      let search = [];

      if (cloneContext.keyword != "" && cloneContext.keyword != null) {
        search.push(["title", "like", `%${cloneContext.keyword}%`]);
      }

      commit("setIsLoading", cloneContext.isLoading == false ? false : true, {
        root: true,
      });
      try {
        const request = await axios.post(
          `/api/query?page=${cloneContext.currentPage}`,
          {
            entity: "awards",
            select: ["*"],
            where: search,
            orderBy: { "column": "", "sort": "" },
            aggregate: { "method": "", "column": "" },
            pagination: {
              isPaginate: (context.perPage != null) ? true : false,
              quantity: cloneContext.perPage != null ? cloneContext.perPage : 0,
            },
          }
        );

        let response = null;
        if (request.data.data == null) {
          response = request.data;
        } else {
          response = request.data.data;
        }

        let returnBody = [];

        for (let x of response) {
          returnBody.push({
            id: x.id,
            image: {
              raw: x.image,
              html: `<img src="${this._vm.$globalUrl}/storage/images/${x.image}" />`
            },
            title: x.title,
            url: {
              raw: x.URL,
              html: `<a href="${x.URL}">${x.URL}</a>`
            },
            awardDate: x.awardDate,
          });
        }

        commit("setIsLoading", false, { root: true });
        return {
          head: ["Cover", "Title", "Link", "Date"],
          body: returnBody,
          pagination: {
            per_page: request.data.per_page,
            current_page: request.data.current_page,
            total_pages: request.data.last_page,
          },
        };
      } catch (error) {
        commit("setIsLoading", false, { root: true });
        throw error;
      }
    },
    async getAward({ commit }, content) {
      commit("setIsLoading", true, { root: true, });

      try {
        const request = await axios.post(
          `/api/query`,
          {
            entity: "awards",
            select: ["*"],
            where: [["id", content.id]],
            orderBy: { "column": "", "sort": "" },
            aggregate: { "method": "", "column": "" },
            pagination: {
              isPaginate: false,
              quantity: 0,
            },
          }
        );

        commit("setIsLoading", false, { root: true });
        return request.data;
      } catch (error) {
        commit("setIsLoading", false, { root: true });
        throw error;
      }
    },
    async createAward({ commit }, content) {
      commit("setIsLoading", true, { root: true, });

      try {
        const request = await axios.post(`/api/award`, content);

        commit("setIsLoading", false, { root: true, });
        return request.data;
      } catch (error) {
        commit("setIsLoading", false, { root: true, });
        throw error;
      }
    },
    async updateAward({ commit }, content) {
      commit("setIsLoading", true, { root: true, });

      try {
        const request = await axios.put(`/api/award/${content.id}`, content.data);

        commit("setIsLoading", false, { root: true, });
        return request.data;
      } catch (error) {
        commit("setIsLoading", false, { root: true, });
        throw error;
      }
    },
    async deleteAward({ commit }, content) {
      commit("setIsLoading", true, { root: true, });

      try {
        const request = await axios.delete(`/api/award/${content}`);

        commit("setIsLoading", false, { root: true, });
        return true;
      } catch (error) {
        commit("setIsLoading", false, { root: true, });
        return false;
      }
    },
  },
};
